import API from "../utils/api";
import axios from "axios";

export const getSellerReportDataApi = async (data) => {
  const response = await API.get('report/sales-report',{
      params: data,
  });
  return {response};
};

export const getBackInStockReportApi = async (data) => {
    const response = await API.get('report/back-in-stock-report',
        {
            params: data,
        });
    return {response};
}

export const getSelectedBackInRequestData = async (id) => {
    const response = await API.get(`report/get-selected-back-in-stock/${id}`);
    return {response};
};

export const getExchangeOrderReportApi = async (data) => {
    const response = await API.get(`order/get-all-exchange-orders`, {params:data});
    return {response};
}

export const offerItemReportApi = async (data) => {
    const response = await API.get('report/offer-report', {params:data});
    return {response};
}

export const getInventoryReportApi = async (data) => {
    const response = await API.get(`report/inventories-report`,{
        params: data,
    });
    return { response };
};

export const getOrderItemReportApi = async (data, cancelToken) => {
    try {
        const response = await API.get(`report/order-items`, {
            params: data,
            cancelToken: cancelToken,
        });
        return { response };
    } catch (error) {
        if (axios.isCancel(error)) {
            console.log("Previous request canceled:", error.message);
        } else {
            throw error;
        }
    }
};

export const exportOrderItemReportApi = async (data) => {
    const response = await API.get(`report/order-items/export`, {
        params: data,
    });
    return { response };
};

export const getHandlingReportApi = async (data) => {
    const response = await API.get(`report/handling-items`,{
        params: data,
    });
    return { response };
};

export const importStockLevelApi = async (data) => {
    const response = await API.post('import-stock-level', data, {'content-type': 'multipart/form-data'});
    return {response};
}

export const exportInventoryHistoryApi = async (data) => {
    const response = await API.get(`report/inventories-report/export`, {
        params: data,
    });
    return { response };
};

export const sellerBrandSuggestionApi = async (text) => {
    const response = await API.get('product/brand-auto-suggestion', {
        params: text,
    });
    return { response };
};

export const customerAutoSuggestionApi = async (text) => {
    const response = await API.get("order/draft/customer-auto-suggestion", {
      params: text,
    });
    return { response };
  };

export const getFinancesSummarySettingApi = async (data) => {
    const response = await API.get('report/finances-summary/settings', {
        params: data,
    });
    return { response };
};

export const getFinancesSummaryApi = async (data) => {
    const response = await API.get('report/finances-summary', {
        params: data,
    });
    return { response };
};

export const exportFinancesSummaryApi = async (data) => {
    const response = await API.get('report/finances-summary/export', {
        params: data,
    });
    return { response };
};

export const getFinancesSalesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-gross-sales', {
        params: data,
    });
    return { response };
};

export const exportFinancesSalesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-gross-sales/export', {
        params: data,
    });
    return { response };
};

export const getFinancesDiscountsDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-discounts', {
        params: data,
    });
    return { response };
};

export const exportFinancesDiscountsDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-discounts/export', {
        params: data,
    });
    return { response };
};

export const getFinancesReturnsDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-returns', {
        params: data,
    });
    return { response };
};

export const exportFinancesReturnsDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-returns/export', {
        params: data,
    });
    return { response };
};

export const getFinancesProductCostDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-product-costs', {
        params: data,
    });
    return { response };
};

export const exportFinancesProductCostDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-product-costs/export', {
        params: data,
    });
    return { response };
};

export const getFinancesShippingIncomeDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-shipping-income', {
        params: data,
    });
    return { response };
};

export const exportFinancesShippingIncomeDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-shipping-income/export', {
        params: data,
    });
    return { response };
};

export const getFinancesReturnShippingIncomeDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-return-shipping-income', {
        params: data,
    });
    return { response };
};

export const exportFinancesReturnShippingIncomeDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-return-shipping-income/export', {
        params: data,
    });
    return { response };
};

export const getFinancesShippingCostSaleDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-shipping-cost-sales', {
        params: data,
    });
    return { response };
};

export const exportFinancesShippingCostSaleDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-shipping-cost-sales/export', {
        params: data,
    });
    return { response };
};

export const getFinancesShippingCostReturnDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-shipping-cost-return', {
        params: data,
    });
    return { response };
};

export const exportFinancesShippingCostReturnDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-shipping-cost-return/export', {
        params: data,
    });
    return { response };
};

export const getFinancesCommissionsDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-commissions', {
        params: data,
    });
    return { response };
};

export const exportFinancesCommissionsDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-commissions/export', {
        params: data,
    });
    return { response };
};

export const getFinancesAdditionalChargesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-additional-charges', {
        params: data,
    });
    return { response };
};

export const exportFinancesAdditionalChargesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-additional-charges/export', {
        params: data,
    });
    return { response };
};

export const getFinancesAgentCommissionDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-agent-commissions', {
        params: data,
    });
    return { response };
};

export const exportFinancesAgentCommissionDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-agent-commissions/export', {
        params: data,
    });
    return { response };
};

export const getFinancesTaxesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-taxes', {
        params: data,
    });
    return { response };
};

export const exportFinancesTaxesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-taxes/export', {
        params: data,
    });
    return { response };
};

export const getFinancesNetSalesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-net-sales', {
        params: data,
    });
    return { response };
};

export const exportFinancesNetSalesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-net-sales/export', {
        params: data,
    });
    return { response };
};

export const getFinancesPaymentsDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-payments', {
        params: data,
    });
    return { response };
};

export const exportFinancesPaymentsDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-payments/export', {
        params: data,
    });
    return { response };
};

export const getFinancesChargebacksDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-chargebacks', {
        params: data,
    });
    return { response };
};

export const getFinancesOtherAdditionalChargesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-other-additional-charges', {
        params: data,
    });
    return { response };
};

export const exportFinancesOtherAdditionalChargesDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-other-additional-charges/export', {
        params: data,
    });
    return { response };
};

export const exportFinancesChargebacksDetailsApi = async (data) => {
    const response = await API.get('report/finances-summary/details-chargebacks/export', {
        params: data,
    });
    return { response };
};

export const getFinancesPaymentsApi = async (data) => {
    const response = await API.get('report/finances-summary/payments', {
        params: data,
    });
    return { response };
};

export const getFinancesDeliveryPartnersApi = async (data) => {
    const response = await API.get('report/finances-summary/delivery-partners', {
        params: data,
    });
    return { response };
};

export const getFinancesPartnerXeroInvoicesApi = async (data) => {
    const response = await API.get('report/finances-summary/partner-xero-invoices', {
        params: data,
    });
    return { response };
};

export const republishPartnerXeroInvoiceApi = async (data) => {
    const response = await API.post("xero/republish-partner-xero-invoice", data);
    return { response };
};

export const getVogaclosetInvoicesApi = async (data) => {
    const response = await API.get('report/vogacloset/invoices', {
        params: data,
    });
    return { response };
};

export const exportVogaclosetDiscountReportApi = async (data) => {
    const response = await API.get('report/vogacloset/export-discount-report', {
        params: data,
    });
    return { response };
};

export const exportXeroInvoiceDetailReportApi = async (data) => {
    const response = await API.get('report/xero-invoices/detail-report/export', {
        params: data,
    });
    return { response };
};

export const goddivaInvoiceReportApi = async (data) => {
    const response = await API.get('report/citygoddess/purchase-invoices', {
        params: data,
    });
    return {response};
};

export const goddivaInvoiceByIdApi = async (data) => {
    const { invoiceId, ...params } = data;
    const response = await API.get('report/citygoddess/purchase-invoices/' + invoiceId, {
        params,
    });
    return {response};
};

export const exportInvoiceRowApi = async (data) => {
    const response = await API.get('report/citygoddess/purchase-invoices/export/'+data, {
        params: data,
    });
    return { response };
};

export async function uploadInvoiceToXeroApi(invoiceId) {
    const response = await API.post('/report/citygoddess/purchase-invoices/upload-to-xero/'+invoiceId, {
        // params: data,
    });
    return {response};
}

export const getSmartReportSettingsApi = async () => {
    const response = await API.get('report/smart-reports/settings');
    return {response};
};

export const getSmartReportModuleColumnsApi = async (moduleKey) => {
    const response = await API.get(`report/smart-reports/module-columns/${moduleKey}`);
    return {response};
};

export const generateSmartReportApi = async (data) => {
    const response = await API.post('report/smart-reports/generate', data);
    return {response};
};

export const getSmartReportHistoryApi = async (data) => {
    const response = await API.get('report/smart-reports/history', {
        params: data,
    });
    return {response};
};

export const getSmartReportByIdApi = async (id) => {
    const response = await API.get(`report/smart-reports/${id}`);
    return {response};
};

export const deleteSmartReportApi = async (id) => {
    const response = await API.delete(`report/smart-reports/${id}`);
    return {response};
};

export const getAiReportSettingsApi = async () => {
    const response = await API.get('report/ai-reports/settings');
    return {response};
};

export const generateAiReportApi = async (data) => {
    const response = await API.post('report/ai-reports/generate', data);
    return {response};
};

export const getAiReportHistoryApi = async (data) => {
    const response = await API.get('report/ai-reports/history', {
        params: data,
    });
    return {response};
};

export const getAiReportByIdApi = async (id) => {
    const response = await API.get(`report/ai-reports/${id}`);
    return {response};
};

export const downloadAiReportApi = async (id) => {
    const response = await API.get(`report/ai-reports/${id}/download`);
    return {response};
};

export const deleteAiReportApi = async (id) => {
    const response = await API.delete(`report/ai-reports/${id}`);
    return {response};
};

export const chatAiReportApi = async (data) => {
    const response = await API.post('report/ai-reports/chat', data);
    return {response};
};

export const confirmAiReportApi = async (data) => {
    const response = await API.post('report/ai-reports/confirm-generate', data);
    return {response};
};